import { ActionTree, ActionContext } from 'vuex'
import { IRootState, FeatureFlagsState } from '@/@types'
import {
  getAllDarklyFlags,
  createDarklyClient,
  onDarklyFeatureFlagChange,
  closeDarklyClient,
  errorHandler,
} from '@/utils'

const updateFlags = (context: ActionContext<FeatureFlagsState, IRootState>) => {
  const newFlags = getAllDarklyFlags()
  context.commit('FEATURE_FLAGS_UPDATED', { ...newFlags })
}

const cleanFlagsStore = (context: ActionContext<FeatureFlagsState, IRootState>) => {
  const flags = {
    isBooGoPromoActive: false,
    runningBlackFriday: 0,
    runningPromotions: 0,
    isLeapYearPromoActive: 0,
  }
  context.commit('FEATURE_FLAGS_UPDATED', flags)
}

const actions: ActionTree<FeatureFlagsState, IRootState> = {
  updateFeatureFlags: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      updateFlags(context)
    } catch (error) {
      const message = errorHandler(error)
      context.dispatch('app/setError', message, { root: true })
    }
  },
  initializeDarkly: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await createDarklyClient()
      await context.dispatch('updateFeatureFlags')
      Object.keys(context.state.flags).map((flag: string) => {
        onDarklyFeatureFlagChange(flag, () => {
          updateFlags(context)
        })
      })
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
  closeDarkly: async (context: ActionContext<FeatureFlagsState, IRootState>) => {
    try {
      await closeDarklyClient()
    } finally {
      cleanFlagsStore(context)
    }
  },
}

export default actions
